<template>
  <div class="question-block">
    <div class="question-block__title">
      <drag-title-block
        class="question-block__drag"
        :title="`${index + 1}${$tr('application.questionCounter.question')}`"
      />

      <div v-if="questionsLength > 1" class="question-block__delete" @click="delete_question">
        <i class="icon icon-recycle_bin"></i>
      </div>
    </div>

    <div class="question-block__question-body">
      <div class="question-block__type">
        <multiselect
          v-model="selected"
          open-direction="bottom"
          track-by="type"
          label="name"
          class="application-select"
          :options="types"
          :show-labels="false"
          :searchable="false"
          allow-empty
          icon_select
        />
      </div>

      <div class="question-block__desc">
        <vcv-tiptap v-model="name" :is-empty="name === '' || name === '<p></p>'" is-lite />

        <!-- <vcv-editor
          :id="'editor-application' + (index + 1)"
          ref="textarea"
          v-model="name"
          :placeholder="$tr('admin_console.response.tests.questions.question')"
          resizable
          auto_height
          :height="230"
          :toolbar-buttons="{
            bold: true,
            italic: true,
            underline: true,
            clean: true
          }"
          name="application"
          :class="['application', { 'application-editor__error': name.length === 0 }]"
        /> -->

        <div v-if="name.length === 0" class="error">{{ $tr('common.requiredField') }}</div>
      </div>

      <div class="question-block__dropdown">
        <div v-if="selected.type === 'enumeration'" class="lists__lists">
          <div v-if="enumerateLists.length > 0" class="lists__lists-container">
            <div class="lists__lists-chosen" @click="isShowListsSelect = !isShowListsSelect">
              <span>{{ listChosenText }}</span>

              <i class="icon-caret" :class="{ 'is-rotate': isShowListsSelect }"></i>
            </div>

            <transition name="slide-fade">
              <div v-if="isShowListsSelect" v-on-clickaway="hideListsSelect" class="lists__lists-select">
                <div class="lists__lists-select-items">
                  <div v-for="list in enumerateLists" :key="list.id" class="lists__lists-select-item">
                    <div class="lists__lists-select-item-left" @click="selectCurrentList(list.id)">
                      {{ list.title }}
                    </div>

                    <div class="lists__lists-select-item-right">
                      <transition name="fade">
                        <div v-if="isListChosen(list.id)" class="lists__lists-select-item-button">
                          <i class="icon-check"></i>
                        </div>
                      </transition>

                      <div class="lists__lists-select-item-button" @click="openListEdit(list.id)">
                        <i class="icon-edit"></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="lists__create-new" @click="openListEdit()">{{ $tr('lists.create-new-list') }}</div>
              </div>
            </transition>
          </div>

          <div v-else class="lists__create-new" @click="openListEdit()">{{ $tr('lists.create-new-list') }}</div>

          <modal v-if="isShowLists" redesign @close="closeLists">
            <template #header>
              <vinput :value="listName" :placeholder="$tr('lists.enter-list-name')" @input="listName = $event" />
            </template>

            <template #body>
              <div class="lists__modal-list">
                <div v-if="listItems.length === 0" class="lists__modal-list-empty">{{ $tr('lists.no-records') }}</div>

                <container group-name="list-items" lock-axis="y" drag-handle-selector=".lists__drag" @drop="listOnDrop">
                  <draggable v-for="(item, itemIndex) in listItems" :key="itemIndex">
                    <div class="lists__modal-item">
                      <div v-if="listItems.length > 1" class="lists__drag">
                        <div class="lists__drag-dots">
                          <div class="lists__drag-dot"></div>
                          <div class="lists__drag-dot"></div>
                          <div class="lists__drag-dot"></div>
                        </div>
                      </div>

                      <vinput :value="item.value" border @input="changeListItem(itemIndex, $event)" />

                      <div class="lists__modal-item-remove" @click="removeListItem(itemIndex)">
                        <i class="icon-recycle_bin"></i>
                      </div>
                    </div>
                  </draggable>
                </container>
              </div>

              <div class="lists__modal-buttons">
                <div class="lists__modal-button" @click="addListItem">{{ $tr('lists.add-option') }}</div>

                <div class="lists__modal-divider"></div>

                <div class="lists__modal-button lists__modal-button-file">
                  <input
                    class="lists__modal-file"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    @change="excelEvent($event.target.files)"
                  />

                  <div class="lists__modal-file-text">{{ $tr('invites.invite.importFromExcel') }}</div>
                </div>
              </div>
            </template>

            <template #footer>
              <div class="lists__modal-footer">
                <vbutton
                  :text="$tr('common.save')"
                  :loading="listLoading"
                  :disabled="listItems.some(x => x.value === '') || listName === '' || listItems.length === 0"
                  @click="saveList"
                />

                <vbutton
                  :text="$tr('common.delete')"
                  color="transparent"
                  icon="icon-bin"
                  :disabled="currentListEdit === null"
                  :loading="listLoading"
                  @click="deleteList"
                />
              </div>
            </template>
          </modal>
        </div>

        <div v-on-clickaway="hideOptions" class="options-dropdown">
          <div class="options-label" :class="{ 'is-active': isOptionsVisible }" @click="toggleOptions">
            {{ $tr('responses.resume.questionnaire.additional') }}
            <!-- <img src="/static/images/elements/module-arrow-right.svg" /> -->
            <i class="icon-caret" :class="{ 'is-rotate': isOptionsVisible }"></i>
          </div>

          <transition name="slide-fade">
            <div v-if="isOptionsVisible" class="options-select options">
              <div class="options-select-option">
                <vchecklabel
                  :label="$tr('vacancy.videoInterview.mandatory')"
                  :value="model.is_required"
                  @input="set_question_required_status"
                />
              </div>

              <div v-if="selected.type === 'enumeration'" class="options-select-option">
                <vchecklabel
                  :value="model.configuration.allow_multiple"
                  :label="$tr('vacancy.tests.form.questions.types.multichoice')"
                  @input="
                    SET_APPLICATION_QUESTION_CONFIG_PROPERTY({
                      questionId: Number(model.id),
                      property: 'allow_multiple',
                      newValue: $event
                    })
                  "
                />
              </div>

              <div v-if="selected.type === 'enumeration'" class="options-select-option">
                <vchecklabel
                  :value="model.configuration.allow_other"
                  :label="$tr('vacancy.preferences.application.addAnswers3')"
                  @input="
                    SET_APPLICATION_QUESTION_CONFIG_PROPERTY({
                      questionId: Number(model.id),
                      property: 'allow_other',
                      newValue: $event
                    })
                  "
                />
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div
        v-if="model.type === 'enumeration' && currentDropoutList.length > 0 && isDropoutModuleEnabled"
        class="question-block__dropdown question-block__dropout"
      >
        <label>{{ $tr('vacancy.settings.internship.questionnaire-select.cutoff-title') }}</label>

        <div class="question-block__dropout-container">
          <div class="question-block__dropout-input" @click="isShowDropoutList = !isShowDropoutList">
            <span v-if="dropoutCount === 0">{{ $tr('lists.no-cut-replies') }}</span>

            <span v-else>{{ $tr('lists.options-selected', { number: dropoutCount }) }}</span>

            <i class="icon-caret" :class="{ 'is-rotate': isShowDropoutList }"></i>
          </div>

          <transition name="slide-fade">
            <div v-if="isShowDropoutList" v-on-clickaway="hideDropoutList" class="question-block__dropout-list">
              <div v-for="item in currentDropoutList" :key="item.id" class="question-block__dropout-list-item">
                <vchecklabel
                  :value="isDropoutAnswer(item.id)"
                  :label="item.value"
                  @input="TOGGLE_DROPOUT_ANSWER({ questionId: Number(model.id), answerId: item.id })"
                />
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="question-block__answers">
        <answers
          :answers="model.answers"
          :question="model"
          :type="selected.type"
          :is-date-min-changed="isDateMinChanged"
          :is-date-max-changed="isDateMaxChanged"
          @changeDateValidMin="changeDateValidMin"
          @changeDateValidMax="changeDateValidMax"
          @setDropoutDate="setDropoutDate"
          @del_answer="delete_answer"
          @add_answer="add_answer"
          @add_drop_answer="add_drop_answer"
          @set_answer="set_answer"
          @setCutOptioin="setCutOptioin"
          @changeDropoutDateMin="changeDropoutDateMin"
          @changeDropoutDateMax="changeDropoutDateMax"
          @setSelectedRange="setSelectedRange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import readXlsxFile from 'read-excel-file';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Answers from '@/routes_new/inner/vacancy/application/components/Answers.vue';
import { mixin as clickaway } from 'vue-clickaway';
import DragTitleBlock from '@/routes_new/inner/vacancy/components/DragTitleBlock.vue';
import Modal from '@/components/Modal.vue';
import { Container, Draggable } from 'vue-smooth-dnd';
import VcvTiptap from '@/components/VcvTiptap/VcvTiptap';

export default {
  name: 'QuestionsRow',

  components: {
    VcvTiptap,
    Answers,
    Modal,
    DragTitleBlock,
    Container,
    Draggable
  },

  mixins: [clickaway],

  props: {
    model: {
      type: Object,
      default: () => {}
    },

    index: {
      type: Number,
      default: 0
    },

    questionsLength: {
      type: [Number, Object],
      default: 0
    }
  },

  data() {
    return {
      isOptionsVisible: false,
      isDateMinChanged: false,
      isDateMaxChanged: false,
      isShowLists: false,
      listLoading: false,
      listName: '',
      listItems: [],
      currentListEdit: null,
      isShowDropoutList: false,
      currentDropoutList: [],
      isShowListsSelect: false,
      types: [
        {
          type: 'single',
          name: this.$tr(`vacancy.preferences.application.single`)
        },
        {
          type: 'multiple',
          name: this.$tr(`vacancy.preferences.application.multiple`)
        },
        {
          type: 'open',
          name: this.$tr(`vacancy.preferences.application.open`)
        },
        {
          type: 'enumeration',
          name: this.$tr(`vacancy.preferences.application.list`)
        },
        {
          type: 'date',
          name: this.$tr(`vacancy.preferences.application.date`)
        },
        {
          type: 'file',
          name: this.$tr(`vacancy.preferences.application.file`)
        }
      ]
    };
  },

  computed: {
    ...mapState('company', { companyId: state => state.company.id }),

    ...mapState('vacancy/application', ['enumerateLists']),

    ...mapState('vacancy_new', { vacancyLanguage: state => state.item.language.code || 'ru' }),

    ...mapGetters('vacancy_new', { modules: 'modules/list' }),

    activedModules() {
      return this.modules.filter(item => item.is_active);
    },

    isDropoutModuleEnabled() {
      if (!this.activedModules || !this.activedModules.length) {
        return false;
      }

      return !!this.activedModules.find(item => item.id === 'survey-screening');
    },

    listChosenText() {
      if (this.model.configuration !== null && this.model.configuration.enumeration_id !== undefined) {
        const currentList = this.enumerateLists.find(x => x.id === this.model.configuration.enumeration_id);

        if (currentList !== undefined) {
          return currentList.title;
        } else {
          return this.$tr('lists.select-list');
        }
      } else {
        return this.$tr('lists.select-list');
      }
    },

    selected: {
      get() {
        let type = this.types.find(el => el.type === this.model.type);
        return type;
      },

      set(val) {
        this.$store.commit('vacancy/application/set_selected_type', {
          id: this.model.id || this.model.local_id,
          type: val.type
        });
      }
    },

    name: {
      get() {
        return this.model.name;
      },

      set(val) {
        this.$store.commit('vacancy/application/set_name_quest', {
          id: this.model.id || this.model.local_id,
          value: val
        });
      }
    },

    answ_length() {
      return this.model.answers ? this.model.answers.length : null;
    },

    current_locale() {
      return this.$store.getters['locale/current'];
    },

    dropoutCount() {
      if (this.model.configuration !== null && this.model.configuration.dropout_answer_ids !== undefined) {
        return this.model.configuration.dropout_answer_ids.length;
      } else {
        return 0;
      }
    }
  },

  watch: {
    isShowLists(val) {
      if (!val) {
        this.currentListEdit = null;
      }
    }
  },

  async created() {
    if (
      this.model.configuration !== undefined &&
      this.model.configuration !== null &&
      this.model.configuration.enumeration_id !== undefined
    ) {
      await this.selectCurrentList(Number(this.model.configuration.enumeration_id), true); // true - first load
    }
  },

  methods: {
    ...mapMutations('vacancy/application', [
      'SET_APPLICATION_QUESTION_CONFIG_PROPERTY',
      'TOGGLE_DROPOUT_ANSWER',
      'CLEAR_DROPOUT_ANSWERS'
    ]),

    ...mapActions('vacancy/application', ['fetchEnumerateLists']),

    excelEvent(file) {
      readXlsxFile(file[0]).then(
        data => {
          const firstColumn = data
            .map(x => {
              if (x[0] !== null) {
                return { value: x[0] };
              }
            })
            .filter(x => x !== undefined);

          this.listItems = [...this.listItems, ...firstColumn];
        },
        function (error) {
          console.error(error);
          // alert("Error while parsing Excel file. See console output for the error stack trace.")
        }
      );
    },

    isListChosen(listId) {
      return (
        this.model.configuration !== null &&
        this.model.configuration.enumeration_id !== undefined &&
        this.model.configuration.enumeration_id === listId
      );
    },

    hideListsSelect() {
      this.isShowListsSelect = false;
    },

    hideDropoutList() {
      this.isShowDropoutList = false;
    },

    addListItem() {
      let sortOrder = 1;

      if (this.listItems.length > 0) {
        sortOrder = Math.max(...this.listItems.map(x => x.sort_order));
        sortOrder += 1;
      }

      this.listItems.push({ value: '', sort_order: sortOrder });
    },

    changeListItem(itemIndex, value) {
      const newValue = { value, sort_order: this.listItems[itemIndex].sort_order || 0 };

      this.listItems.splice(itemIndex, 1, newValue);
    },

    removeListItem(itemIndex) {
      this.listItems.splice(itemIndex, 1);
    },

    closeLists() {
      this.isShowLists = false;
      this.listItems = [];
    },

    async openListEdit(listId) {
      if (listId !== undefined) {
        this.listLoading = true;
        this.currentListEdit = listId;

        await Axios.get(`/v3/enumerations/${listId}?with[0]=items`)
          .then(response => {
            this.listName = response.data.title;

            if (response.data._embedded !== undefined && response.data._embedded.items !== undefined) {
              this.listItems = response.data._embedded.items.map(x => ({
                id: x.id,
                sort_order: x.sort_order,
                value: x.value
              }));
            }
            this.isShowLists = true;
          })
          .finally(() => {
            this.listLoading = false;
          });
      } else {
        this.listName = '';
        this.listItems = [];
        this.currentListEdit = null;
        this.isShowLists = true;
      }
    },

    async selectCurrentList(listId, firstLoad = false) {
      this.SET_APPLICATION_QUESTION_CONFIG_PROPERTY({
        questionId: Number(this.model.id),
        property: 'enumeration_id',
        newValue: listId
      });

      await Axios.get(`/v3/enumerations/${listId}?with[0]=items`)
        .then(response => {
          if (response.data._embedded !== undefined && response.data._embedded.items !== undefined) {
            const items = response.data._embedded.items.sort((a, b) =>
              a.sort_order > b.sort_order ? 1 : b.sort_order > a.sort_order ? -1 : 0
            );

            this.currentDropoutList = items;

            if (!firstLoad) {
              this.CLEAR_DROPOUT_ANSWERS({ questionId: Number(this.model.id) });
            }
          }

          this.isShowListsSelect = false;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    isDropoutAnswer(itemId) {
      return this.model.configuration.dropout_answer_ids !== undefined
        ? this.model.configuration.dropout_answer_ids.includes(itemId)
        : false;
    },

    listOnDrop(droppedItems) {
      // Перемешивание после отпускания кнопки мыши
      const { removedIndex, addedIndex, payload } = droppedItems;
      if (removedIndex === null && addedIndex === null) return this.listItems;

      const result = [...this.listItems];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      // Добавление sort_order свойства
      const newOrderedList = [];
      let currentOrder = 0;

      result.forEach(item => {
        const newItem = Object.assign({}, item);
        currentOrder += 1000;
        newItem.sort_order = currentOrder;

        newOrderedList.push(newItem);
      });

      this.listItems = newOrderedList;
    },

    async saveList() {
      this.listLoading = true;

      if (this.currentListEdit) {
        // Редактирование списка
        const data = { title: this.listName, company_id: Number(this.companyId), items: this.listItems };

        await Axios.patch(`/v3/enumerations/${this.currentListEdit}`, data)
          .then(async () => {
            this.$noty.success(this.$tr('profile.info.save_success'));
            await this.fetchEnumerateLists(this.companyId);
            this.isShowLists = false;
            // clear modal
            this.listName = '';
            this.listItems = [];
            this.currentListEdit = null;
          })
          .finally(() => {
            this.listLoading = false;
          });
      } else {
        // Новый список
        const data = { title: this.listName, company_id: Number(this.companyId), items: this.listItems };

        await Axios.post('/v3/enumerations', data)
          .then(async response => {
            this.$noty.success(this.$tr('profile.info.save_success'));
            await this.fetchEnumerateLists(this.companyId);
            this.SET_APPLICATION_QUESTION_CONFIG_PROPERTY({
              questionId: this.model.id,
              property: 'enumeration_id',
              newValue: response.data.id
            });
            this.isShowLists = false;
            // clear modal
            this.listName = '';
            this.listItems = [];
            this.currentListEdit = null;
          })
          .finally(() => {
            this.listLoading = false;
          });
      }
    },

    async deleteList() {
      this.listLoading = true;

      await Axios.delete(`/v3/enumerations/${this.currentListEdit}`)
        .then(async () => {
          this.$noty.success(this.$tr('lists.list-deleted'));
          await this.fetchEnumerateLists(this.companyId);
          this.isShowLists = false;
          // clear modal
          this.listName = '';
          this.listItems = [];
          this.currentListEdit = null;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    set_question_required_status(e) {
      this.$store.commit('vacancy/application/set_required_status', {
        id: this.model.id || this.model.local_id,
        status: e
      });
    },

    delete_question() {
      this.$store.commit('vacancy/application/delete_question', this.model.id || this.model.local_id);
      this.set_changes(true);
    },

    delete_answer(v) {
      this.$store.commit('vacancy/application/delete_answer', {
        id_quest: this.model.id || this.model.local_id,
        id_answer: v
      });
      this.set_changes(true);
    },

    add_answer(v) {
      if (this.answ_length < 30) {
        let text = '';
        if (v === 'other') {
          text = this.$tr('vacancy.preferences.application.addAnswers3', {}, { locale: this.vacancyLanguage });
        }
        this.$store.commit('vacancy/application/add_answer', {
          id: this.model.id || this.model.local_id,
          value: v,
          cont: text,
          is_dropout: false
        });
        this.set_changes(true);
      }
    },

    add_drop_answer(v) {
      if (this.answ_length < 30) {
        let text = '';
        if (v === 'other') {
          text = this.$tr('vacancy.preferences.application.addAnswers3');
        }
        this.$store.commit('vacancy/application/add_answer', {
          id: this.model.id || this.model.local_id,
          value: v,
          cont: text,
          is_dropout: true
        });
        this.set_changes(true);
      }
    },

    set_answer(v) {
      this.$store.commit('vacancy/application/set_answer', {
        question_id: this.model.id || this.model.local_id,
        answer_id: v.id,
        value: v.value
      });
      this.set_changes(true);
    },

    setCutOptioin(v) {
      this.$store.commit('vacancy/application/setCutOptioin', {
        question_id: this.model.id || this.model.local_id,
        answer_id: v.id,
        is_dropout: v.is_dropout
      });
      this.set_changes(true);
    },

    setDropoutDate(v) {
      this.$store.commit('vacancy/application/setDropoutDate', {
        question_id: this.model.id || this.model.local_id,
        is_dropout_date: v
      });
      this.set_changes(true);
    },

    changeDropoutDateMin(v) {
      this.$store.commit('vacancy/application/setDropoutDateMin', {
        question_id: this.model.id || this.model.local_id,
        dropout_date_min: v.dropout_date_min
      });
      // this.set_changes(true);
      this.setDateMinChanges(true);
    },

    changeDropoutDateMax(v) {
      this.$store.commit('vacancy/application/setDropoutDateMax', {
        question_id: this.model.id || this.model.local_id,
        dropout_date_max: v.dropout_date_max
      });
      this.setDateMaxChanges(true);
    },

    changeDateValidMin(v) {
      this.$store.commit('vacancy/application/changeDateValidMin', {
        question_id: this.model.id || this.model.local_id,
        isDateValid: v
      });
    },

    changeDateValidMax(v) {
      this.$store.commit('vacancy/application/changeDateValidMax', {
        question_id: this.model.id || this.model.local_id,
        isDateValid: v
      });
    },

    // setSelectedRange(v) {
    //   this.$store.commit('vacancy/application/setDropoutDateMax', {
    //     question_id: this.model.id || this.model.local_id,
    //     is_indicated_dates: v.is_indicated_dates
    //   });
    //   this.setDateMaxChanges(true);
    // },

    setSelectedRange(v) {
      this.$store.commit('vacancy/application/setSelectedRange', {
        question_id: this.model.id || this.model.local_id,
        is_indicated_dates: v.is_indicated_dates
      });
    },

    set_changes(v) {
      this.$store.commit('vacancy/application/set_changes', v);
    },

    setDateMinChanges(v) {
      this.isDateMinChanged = v;
    },

    setDateMaxChanges(v) {
      this.isDateMaxChanged = v;
    },

    question_error(v) {
      if (v === '') {
        return this.$tr('common.requiredField');
      } else {
        return '';
      }
    },

    toggleOptions() {
      this.isOptionsVisible = !this.isOptionsVisible;
    },

    hideOptions() {
      this.isOptionsVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

i.icon-caret {
  transform: rotate(0deg);
  font-size: 13px;
  transition: transform 0.25s;
}

i.icon-caret.is-rotate {
  transform: rotate(180deg);
  transition: transform 0.25s;
}

.question-block {
  position: relative;
  box-shadow: $box-shadow;
  margin-bottom: 20px;
  border-radius: 4px;
  background: $white;
  border: 1px solid $grey-light;

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $grey-light;
  }

  &__drag {
    flex: 1;
  }

  &__delete {
    width: 47px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    color: $red;
    background: $background;
    transition: all ease-in-out 0.3s;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover {
      background: $red-light;
      color: $white;
      transition: all 0.3s;
    }
  }

  &__question-body {
    padding: 15px 20px;
    // background: $background;
  }

  .application-select {
    width: 280px;
    max-width: 280px;

    ::v-deep span {
      @include mixin-text-main;
    }
  }

  &__type {
    padding-bottom: 10px;
  }

  &__desc {
    position: relative;
  }

  &__dropdown {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  & > .row-block {
    position: relative;
  }

  .row-block.options {
    margin-top: 20px;

    & > div {
      margin-right: 25px;
    }
  }

  &__dropout {
    @include mixin-text-main;
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;

    label {
      margin-bottom: 3px;
    }
  }

  &__dropout-input {
    width: 350px;
    height: 39px;
    padding: 0 10px;
    border: 1px solid $grey-light;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: $green;
      transition: color 0.3s;
    }
  }

  &__dropout-list {
    box-shadow: $box-shadow;
    border: 1px solid $grey-light;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: $white;
    padding: 15px 10px;
    position: absolute;
    top: 62px;
    left: 0;
    right: 0;
    width: 350px;
    max-height: 260px;
    overflow-y: auto;
    z-index: 10;
  }

  &__dropout-list-item {
    margin: 3px 0;
  }
}

.application-editor__error {
  border: 1px solid #f65046;
}

.options-dropdown {
  @include mixin-text-main;
  position: relative;
  margin-left: auto;
}

.options-label {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  height: 39px;
  border: 1px solid $grey-light;
  background: $white;
  box-sizing: border-box;
  border-radius: 2px;
  min-width: 176px;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: $green;
    transition: color 0.3s;
  }

  img {
    transition: all ease-in-out 0.4s;
    transform: rotate(90deg);
  }

  &.is-active {
    img {
      transition: all ease-in-out 0.4s;
      transform: rotate(270deg);
    }
  }
}

.options-select {
  position: absolute;
  background: #fff;
  box-shadow: $box-shadow;
  border: 1px solid $grey-light;
  box-sizing: border-box;
  border-radius: 2px;
  right: 0;
  top: 38px;
  padding: 10px 10px;
  z-index: 2;
  transition: all ease-in-out 0.4s;

  ::v-deep {
    .vcheckbox_label,
    .checkbox_label {
      white-space: nowrap;
    }
  }
}

.options-select-option {
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.lists {
  &__lists {
    @include mixin-text-main;
    height: 39px;
    width: 350px;
    border: 1px solid $grey-light;
    color: $main-dark;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  &__lists-container {
    width: 100%;
    height: 39px;
    display: flex;
    align-items: center;
  }

  &__lists-chosen {
    @include mixin-text-main;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 39px;
    width: 100%;
    padding: 0 10px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: $green;
      transition: color 0.3s;
    }
  }

  &__lists-select {
    box-shadow: $box-shadow;
    border: 1px solid $grey-light;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: $white;
    padding: 15px 10px 5px;
    position: absolute;
    top: 37px;
    left: -1px;
    right: 0;
    width: 350px;
    max-height: 350px;
    z-index: 10;
  }

  &__lists-select-items {
    border-bottom: 1px solid $grey-light;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    margin-bottom: 5px;
    max-height: 222px;
    overflow-y: auto;
  }

  &__lists-select-item {
    display: flex;
    padding: 2px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: color 0.35s;
  }

  &__lists-select-item-left {
    @include mixin-text-main;
    flex: 1;

    &:hover {
      color: $green;
      transition: color 0.35s;
    }
  }

  &__lists-select-item-right {
    display: flex;

    > * {
      margin: 0 3px;
    }
  }

  &__lists-select-item-button {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      transition: color 0.3s;
    }

    i.icon-check {
      font-size: 16px;
      color: $green;
    }

    i.icon-edit {
      font-size: 18px;
    }

    i.icon-edit:hover {
      color: $green;
      transition: color 0.3s;
    }
  }

  &__create-new {
    width: 100%;
    height: 39px;
    display: flex;
    align-items: center;
    color: $grey;
    justify-content: center;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: $green;
      transition: color 0.3s;
    }
  }

  // modal
  &__modal-list {
    margin: 30px 0;
    max-height: 50vh;
    overflow-y: auto;
    padding-right: 7px;
  }

  &__modal-list-empty {
    color: $grey;
    text-align: center;
  }

  &__modal-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 7px;

    .vinput {
      flex: 1;
    }
  }

  &__modal-item-remove {
    width: 26px;
    height: 26px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    i {
      font-size: 17px;
      transition: color 0.4s;
    }

    &:hover {
      i {
        color: $red;
        transition: color 0.4s;
      }
    }
  }

  &__modal-buttons {
    display: flex;
    justify-content: space-around;
    margin: 20px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid $grey-light;
  }

  &__modal-button {
    @include mixin-text-main;
    color: $grey;
    padding: 5px 10px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: color 0.3s;

    &:hover {
      color: $green;
      transition: color 0.3s;
    }
  }

  &__modal-divider {
    height: 24px;
    width: 1px;
    background: $grey-light;
  }

  &__modal-file {
    position: absolute;
    width: calc(100% + 10px);
    height: calc(100% + 5px) !important;
    padding: 0;
    top: -5px;
    left: -10px;
    opacity: 0;
    cursor: pointer;

    &::-webkit-file-upload-button {
      cursor: pointer;
    }
  }

  &__modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      margin: 0 5px;
    }
  }

  &__drag {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 20px;
    height: 30px;

    &:hover,
    &:focus,
    &:active {
      .answer__drag-dot {
        background: $grey;
        transition: background 0.3s;
      }
    }
  }

  &__drag-dots {
    text-align: center;
    display: block;
    margin-right: 10px;
  }

  &__drag-dot {
    width: 4px;
    height: 4px;
    background: $grey-light;
    border-radius: 50%;
    margin: 3px 2px;
    display: block;
    transition: background 0.3s;
  }
}
</style>
